<template>
	<section>
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true"  size="mini">
				<el-form-item>
					<add-button  @select-type="handleAdd()" ></add-button>
				</el-form-item>
			</el-form>
		</el-col>
		<!--列表-->
		<el-table :data="soundList" highlight-current-row v-loading="listLoading" style="width: 100%;" border  :max-height="formHeight" size="mini">
			<el-table-column type="index" label="序号">
			</el-table-column>
			<el-table-column prop="name" label="名称" sortable>
			</el-table-column>
			<el-table-column prop="keywords" label="关键字">
			</el-table-column>
			<el-table-column label="操作" width="350">
				<template slot-scope="scope">
					<table-update-button  @select-type="handleEdit(scope.$index, scope.row)" ></table-update-button>
					<table-delete-button  @select-type="handleDel(scope.$index, scope.row)"  v-if="usertype==0"></table-delete-button>
				</template>
			</el-table-column>
		</el-table>

		<!--From界面-->
		<el-dialog :title="type" :visible.sync="formVisible" :close-on-click-modal="false" width="60%" top="15vh">
			<el-form :model="formdevice" label-width="120px" ref="formdevice"  :rules="formRules" >
				<el-form-item label="名称" prop="name">
					<el-input v-model="formdevice.name" ></el-input>
				</el-form-item>
				<el-form-item label="关键字" prop="keywords">
					<el-input v-model="formdevice.keywords" ></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="submitData" :loading="loading">提交</el-button>
			</div>
		</el-dialog>

	</section>
</template>

<script>
	import {addSoundType,updateSoundType,getSoundTypeList,deleteSound} from '../../api/api';

	import TableUpdateButton from '../../components/myButton/TableUpdateButton.vue'
	import AddButton from '../../components/myButton/AddButton.vue'
	import TableDeleteButton from '../../components/myButton/TableDeleteButton.vue'

	export default {
	components: { AddButton,TableUpdateButton,TableDeleteButton},
		data() {
			return {
				soundList: [],
				listLoading: false,

				formVisible: false,//修改界面是否显示
				loading: false,

				formHeight:0,
				//界面数据
				formdevice: {
					id: 0,
					name: '',
					keywords:'',
				},
				formRules: {
					name: [
						{ required: true, message: '请输入姓名', trigger: 'blur' }
					],
					keywords: [
						{ required: true, message: '请输入关键字', trigger: 'blur' }
					]
				},
				type:'新增',
				usertype:sessionStorage.getItem("type"),
			}
		},
		methods: {
			getSoundList(){
                getSoundTypeList({}).then((res) => { 
					var resdata=res.data;
					if(resdata.result=="true"||resdata.result==true){
						this.soundList=resdata.datas;
					}else{
						this.$message({
							message: "操作失败，请重试",
							type: 'error'
						})
					}
                });
			}, 
			//显示修改界面
			handleEdit: function (index, row) {
				this.formVisible = true;
				if( this.$refs.formdevice!=undefined){
               		this.$refs.formdevice.resetFields();
				}
				this.type='修改';
				this.formdevice = Object.assign({}, row);
			},
			handleDel(index, row){
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					let formData = new FormData();
					formData.append("id", row.id.toString());
					deleteSound(formData).then((res) => {
						this.listLoading = false;
						let resData = res.data;
						if (resData.result == true||resData.result == "true") {
							this.$message({
								message: '删除成功',
								type: 'success'
						})}else{
							this.$message({
								message: "删除失败",
								type: 'error'
							});
						}
						this.getSoundList();
					});
				}).catch(() => {

				});
			},
			//显示新增界面
			handleAdd: function () {
				this.formVisible = true;
				if( this.$refs.formdevice!=undefined){
               		this.$refs.formdevice.resetFields();
				}
				this.type='新增';
			},
            //Form表单提交
            submitData:function(){
                if(this.type=='修改'){
                   this.editSubmit();
                }else{
					this.addSubmit();
                }
			},
			//添加
			addSubmit: function () {
				this.$refs.formdevice.validate((valid) => {
					if (valid) {
						this.loading = true;

						let param = new URLSearchParams();
						param.append('name', this.formdevice.name);
						param.append('keywords', this.formdevice.keywords);

						addSoundType(param).then((res) => {
							this.loading = false;
							let resData = res.data;
							if(resData.result=="true"||resData.result==true){
								this.$message({
									message: '添加成功',
									type: 'success'
								});
								this.formVisible=false;
								this.getSoundList();
							}else{
								this.$message({
									message: resData.msg,
									type: 'error'
								})
							}
						});
					}
				})
				
            },
            //修改
			editSubmit: function () {
				this.$refs.formdevice.validate((valid) => {
					if (valid) {
						this.loading = true;
				
						let param = new URLSearchParams();
						param.append('name', this.formdevice.name);
						param.append('keywords', this.formdevice.keywords);
						param.append('id', this.formdevice.id);

						updateSoundType(param).then((res) => {
							this.loading = false;
							let resData = res.data;
							if(resData.result=="true"||resData.result==true){
								this.$message({
									message: '修改成功',
									type: 'success'
								});
								this.formVisible=false;
								this.getSoundList();
							}else{
								this.$message({
									message: resData.msg,
									type: 'error'
								})
							}
						});
					}
				})
			},
            //取消按钮
            cancleSubmit:function(){
				this.formVisible=false;
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-120;
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)                                                 
			this.getSoundList();
		}
	}

</script>

<style scoped>
  

	#smallMapCon{
		float: left;
		width: 42%;
		margin-right: 2%;
		height: 350px;
	}
	#smallMap{
		width: 100%;
		height: 300px;
	}
	.dialog-footer{
		text-align: right;
	}
	.isShow{
		display: block;
	}
	.notShow{
		display: none;
	}


	
</style>


// WEBPACK FOOTER //
// SoundManage.vue?9de2fe8a